<template>
    <el-row id="loginForm" justify="center" style="height: inherit" type="flex">
        <el-col :lg="5" :md="10" :sm="15" :xl="5" :xs="24">
            <el-card style="min-height: 350px; margin-top: 50px;">
                <template #header>
                    <div style="text-align: center; font-size: 1.3rem;">
                        {{(null != config? config.sysTitle: appName)}}
                    </div>
                </template>
                <el-form :model="login" :rules="rules" ref="form">
                    <el-form-item prop="userId">
                        <el-input
                                id="userId"
                                placeholder="請輸入帳號(學號或員工編號)"
                                prefix-icon="el-icon-user"
                                v-model="login.userId"
                        ></el-input>
                    </el-form-item>
                    <el-form-item prop="password" type="password">
                        <el-input
                                :show-password="true"
                                placeholder="請輸入密碼"
                                prefix-icon="el-icon-lock"
                                v-model="login.password"
                        >

                        </el-input>
                    </el-form-item>
                    <el-form-item style="margin: 0;">
                        <table style="width: 100%">
                            <tr>
                                <td>
                                    <el-checkbox v-model="login.remember">記住我</el-checkbox>
                                </td>
                                <td style="text-align: center;">
                                    <a :href="'https://chart.googleapis.com/chart?cht=qr&chs=200x200&chl='.concat(currentUrl).concat('&coe=UTF-8')" title="QR Code Online" target="_blank">
                                        <img style="height: 5em;"
                                            :src="'https://chart.googleapis.com/chart?cht=qr&chs=200x200&chl='.concat(currentUrl).concat('&coe=UTF-8')" alt="QR Code Online" border="0">
                                    </a>
                                </td>
                            </tr>
                        </table>
                    </el-form-item>
                    <el-button
                            @click="submit"
                            style="width: 100%;"
                            type="primary"
                    >
                        登入
                    </el-button>
                </el-form>
            </el-card>

        </el-col>

    </el-row>
</template>

<script>
    import {mapActions, mapGetters, mapState} from 'vuex';
    import appNameMixin from '../appNameMixin';

    export default {
        name: 'Login',
        mixins: [appNameMixin],
        data: () => ({
            login: {
                userId: '',
                password: '',
                remember: true
            },
            rules: {
                userId: [
                    {required: true, message: '請輸入帳號', trigger: 'blur'},
                ],
                password: [
                    {required: true, message: '請輸入密碼', trigger: 'blur'}
                ]
            }
        }),
        computed: {
            ...mapState('auth', ['showFailureMessage', 'home']),
            ...mapState({loading: 'loading'}),
            ...mapGetters({authenticated: 'auth/authenticated'}),
            ...mapState('config', ['config']),
            currentUrl() {
                return window.location;
            }
        },
        methods: {
            async submit() {
                const form = this.$refs.form;
                form.validate(async (valid) => {
                    if (valid) {
                        if (await this.authenticate(this.login)) {
                            const {redirect} = this.$route.query;
                            form.resetFields();
                            await this.$router.replace(
                                redirect && redirect !== '/' ? redirect : this.home);
                        } else {
                            this.$message({
                                message: '帳號或密碼錯誤，請重新輸入',
                                type: 'warning'
                            });
                            form.resetFields();
                        }
                    }
                });
            },
            ...mapActions({
                authenticate: 'auth/authenticate'
            }),

            async onEnter(e) {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    e.stopPropagation();
                    await this.submit();
                }
            }
        },

        created() {
            document.addEventListener('keyup', this.onEnter);
        },

        destroyed() {
            document.removeEventListener('keyup', this.onEnter);
        }
    }
</script>

<style>

</style>